import { render, staticRenderFns } from "./Bots.vue?vue&type=template&id=08d58b56&"
import script from "./Bots.vue?vue&type=script&lang=js&"
export * from "./Bots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports